import { useState, useContext } from "react";
import { useHooksAuth } from "../../hooks";
import { GlobalContext } from "../../contexts/GlobalContext";
import { CustomHeader } from "./CustomHeader";
import { CustomSidebar } from "./CustomSidebar";
import { CustomFooter } from "./CustomFooter";
import { PageHome, PageLogin } from "../../modules";

export function CustomLayout({ children }) {
    const { auth } = useHooksAuth();
    const { isDarkMode } = useContext(GlobalContext);
    const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

    if (!auth) {
        return <PageLogin />;
    }

    const names = auth.data?.first_name || "";
    const email = auth.data?.email || "";

    return (
        <div
            className={`app-wrapper ${isDarkMode ? "dark" : ""}`}
            data-theme={isDarkMode ? "dark" : "light"}
        >
            <CustomSidebar collapsed={sidebarCollapsed} />
            <div className={`app-main ${sidebarCollapsed ? "expanded" : ""}`}>
                <CustomHeader
                    onToggleSidebar={() =>
                        setSidebarCollapsed(!sidebarCollapsed)
                    }
                />
                <main className="app-content">
                    <div className="welcome-banner">
                        <div className="welcome-flex">
                            <div className="welcome-profile">
                                <i className="fas fa-user-circle welcome-avatar-icon"></i>
                                <div className="welcome-info">
                                    <h5>{names || "Bienvenido"}</h5>
                                    <small>
                                        <i className="fas fa-envelope"></i>
                                        {email}
                                    </small>
                                </div>
                            </div>
                            <div className="welcome-date">
                                <i className="fas fa-calendar-alt"></i>
                                <span>
                                    {new Date().toLocaleDateString("es-ES", {
                                        weekday: "long",
                                        year: "numeric",
                                        month: "long",
                                        day: "numeric",
                                    })}
                                </span>
                            </div>
                        </div>
                    </div>

                    <PageHome>{children}</PageHome>
                </main>
                <CustomFooter />
            </div>
        </div>
    );
}
